/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `none` - None
* `my_emissions` - My Emissions
* `off_platform` - Off-platform
 */
export type PriorYearSourceEnum = typeof PriorYearSourceEnum[keyof typeof PriorYearSourceEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriorYearSourceEnum = {
  none: 'none',
  my_emissions: 'my_emissions',
  off_platform: 'off_platform',
} as const;
